/**
 * 전화번호 마스킹 처리
 * "01012345678" → "010-12**-**78"
 * 11자리: XXX-XX**-**XX
 * 10자리: XXX-X**-**XX
 */
export function maskPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');

  if (digits.length === 11) {
    // 010-12**-**78
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 5) + '**';
    const part3 = '**' + digits.slice(9, 11);
    return `${part1}-${part2}-${part3}`;
  }

  if (digits.length === 10) {
    // 02-1**-**78 or 031-1**-**78 style
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 4) + '**';
    const part3 = '**' + digits.slice(8, 10);
    return `${part1}-${part2}-${part3}`;
  }

  // 그 외: 원본 반환
  return phone;
}
